import styles from './EndoDesc.module.scss';
import { Stack } from '../../../shared/ui/Stack/Stack';
import { Text } from '../../../shared/ui/Text/Text';

const EndoDesc = () => {
    return ( 
        <div className={styles.container}>
            <Stack
                direction = 'column'
                gap = '32'
                justifyContent='justifyCenter'
                alignItems ='alignCenter'
                className={styles.content}>
                <Text
                    size ='m'
                    className={styles.title}>
                        Почему важно лечить корневые каналы?
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Инфицирование пульпы происходит из-за кариеса, глубокого пломбирования или травмы зуба.
                        Симптомы могут включать боль, длительную чувствительность к теплу или холоду, 
                        изменение цвета зуба, отек и болезненность десен, неприятный привкус во рту. 
                        С другой стороны, симптомов может не быть вообще. Если воспаление не лечить, 
                        это может в конечном итоге вызвать боль, отек и потерю костной ткани.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Пульпа состоит из мягкой ткани, включая нервы и кровеносные сосуды, 
                        и простирается от коронки до кончиков корня. Лечение корневых каналов подразумевает 
                        удаление инфицированной пульпы из внутренней части зуба. Это предотвращает 
                        распространение инфекции и может помочь спасти зуб, который в противном случае 
                        пришлось бы удалить.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Качественное эндодонтическое лечение крайне важно, так как после лечения канала, зуб будет служить базой для 
                        коронок или других ортопедических конструкций.
                </Text>
                <Text
                    size ='m'
                    className={styles.text}>
                        Большинство пациентов откладывают визит к стоматологу, 
                        опасаясь болезненности предстоящих манипуляций. 
                        Однако на сегодняшний день существуют современные
                        методы обезболивания, которые позволяют полностью исключить 
                        возможные болевые ощущения. 
                </Text>            
                <Text
                    size ='m'
                    className={styles.text}>
                        Будьте уверены, мы очень бережно и профессионально подходим 
                        к лечению корневых каналов, используем современные технологии, 
                        инструменты и эндодонтические материалы.
                        Работаем над тем, чтобы предотвратить осложенения, спасти инфицированные и сильно-разрушенные зубы, 
                        при этом обеспечивая вам комфорт и расслабление.
                </Text>
            </Stack>
        </div>
    );
}

export default EndoDesc;